import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { CanActivateFn, Router } from '@angular/router';
import { User } from 'firebase/auth';
import { firstValueFrom } from 'rxjs';

import { AuthService } from '../services/auth.service';

const getResolvedUser = async (auth: Auth): Promise<User | null> => {
  await auth.authStateReady();
  return auth.currentUser;
};

const getProfileUsername = async (
  authService: AuthService,
  uid: string,
): Promise<string> => {
  const profile = await firstValueFrom(authService.profileForUser$(uid));
  const username = profile.username;
  return typeof username === 'string' ? username.trim() : '';
};

export const authGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const auth = inject(Auth);
  const user = await getResolvedUser(auth);

  return user ? true : router.createUrlTree(['/']);
};

export const guestGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const auth = inject(Auth);
  const user = await getResolvedUser(auth);

  return user ? router.createUrlTree(['/my-data']) : true;
};

export const usernameRequiredGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const auth = inject(Auth);
  const authService = inject(AuthService);
  const user = await getResolvedUser(auth);
  if (!user) {
    return router.createUrlTree(['/']);
  }

  const username = await getProfileUsername(authService, user.uid);
  return username ? true : router.createUrlTree(['/choose-username']);
};

export const chooseUsernameGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const auth = inject(Auth);
  const authService = inject(AuthService);
  const user = await getResolvedUser(auth);
  if (!user) {
    return router.createUrlTree(['/']);
  }

  const username = await getProfileUsername(authService, user.uid);
  return username ? router.createUrlTree(['/my-data']) : true;
};
